import UserDetailsRedux from './user_details_redux';

export default UserDetailsRedux;
